import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {

  title = "angular-dashboard-page";

  constructor(private oidcSecurityService: OidcSecurityService, private router: Router){}

  ngOnInit(): void {
    
    // this.oidcSecurityService.isAuthenticated().subscribe((res: any) => {
    //   console.log('llllllll:',res);
      
    //   if(res || res == true) {
    //     this.router.navigate(['/admin/dashboard']);
    //   } else {
    //     this.oidcSecurityService.authorize();
    //   }
    // })
  }
}
